import { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  DialogContent,
  FormHelperText,
} from "@mui/material";
//Import from project
import "../../../Style/dialogstyle.scss";
import moment from "moment";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import {
  SelectStudentByClass,
  SelectSubjectByClassId,
} from "../../Include/DynamicSelect/DynamicSelect";
import { DialogTitleComp } from "../../../Utils/Component";
import {
  CREATE_TEACHING_TIME,
  UPDATE_TEACHING_TIME,
} from "../../../Schema/TeachingTime";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";

export default function TeachingTimeForm({
  open,
  classId,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
}) {
  // Change Language
  const { t, setAlert, language } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [selectedStudents, setSelectedStudents] = useState([]);
  const [studentVal, setStudentVal] = useState({
    id: "",
    title: "",
    // avatar: "",
  });

  const [createTeachingTime] = useMutation(CREATE_TEACHING_TIME, {
    onCompleted: ({ createTeachingTime }) => {
      setLoading(false);

      if (createTeachingTime?.isSuccess === true) {
        setAlert(true, "success", createTeachingTime?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createTeachingTime?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateTeachingTime] = useMutation(UPDATE_TEACHING_TIME, {
    onCompleted: ({ updateTeachingTime }) => {
      setLoading(false);

      if (updateTeachingTime?.isSuccess === true) {
        setAlert(true, "success", updateTeachingTime?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateTeachingTime?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    remark: Yup.string(),
    // date: Yup.string().required(t("required")),
    fromDate: Yup.string().required(t("required")),
    toDate: Yup.string().required(t("required")),
    lesson: Yup.string().required(t("required")),
    endTime: Yup.string(),
    startTime: Yup.string(),
    subjectId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      lesson: "",
      // date: moment(),
      fromDate: "",
      toDate: "",
      remark: "",
      endTime: "",
      startTime: "",
      subjectId: { id: "", title: "" },
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);

      if (dialogTitle === "Update") {
        updateTeachingTime({
          variables: {
            id: editData?._id,
            input: {
              // studentIds: selectedStudents?.map((e) => e?.id).filter((e) => e),
              studentIds: [studentVal?.id],
              endTime: values?.endTime,
              subjectId: values?.subjectId?.id || null,
              startTime: values?.startTime,
              remark: values?.remark,
              classId: classId || null,
              fromDate: moment(values?.fromDate).format("YYYY-MM-DD"),
              toDate: moment(values?.toDate).format("YYYY-MM-DD"),
              // date: moment(values?.date).format("YYYY-MM-DD"),
              lesson: values?.lesson,
            },
          },
        });
      } else {
        createTeachingTime({
          variables: {
            input: {
              // studentIds: selectedStudents?.map((e) => e?.id).filter((e) => e),
              studentIds: [studentVal?.id],
              lesson: values?.lesson,
              remark: values?.remark,
              // date: moment(values?.date).format("YYYY-MM-DD"),
              fromDate: moment(values?.fromDate).format("YYYY-MM-DD"),
              toDate: moment(values?.toDate).format("YYYY-MM-DD"),
              classId: classId || null,
              endTime: values?.endTime,
              startTime: values?.startTime,
              subjectId: values?.subjectId?.id || null,
            },
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  // console.log("editData:::", editData);

  useEffect(() => {
    if (dialogTitle === "Update" && editData) {
      setFieldValue("subjectId", {
        id: editData?.subjectId?._id,
        title:
          language == "en"
            ? editData?.subjectId?.enName
            : editData?.subjectId?.khName,
      });
      setFieldValue("date", moment(editData?.date));
      setFieldValue("remark", editData?.remark);
      setFieldValue("lesson", editData?.lesson);
      setFieldValue("endTime", editData?.endTime);
      setFieldValue("startTime", editData?.startTime);
      setFieldValue("fromDate", editData?.fromDate);
      setFieldValue("toDate", editData?.toDate);

      // const data = editData?.studentIds?.map((e) => ({
      //   id: e?._id,
      //   title: `${e?.familyName} ${e?.studentName}`,
      //   // avatar: e?.profile || "",
      // }));
      // setSelectedStudents(data || []);
      // setStudentVal(data[0]);
      setStudentVal({
        id: editData?.studentId?._id,
        title:
          editData?.studentId?.familyName +
          " " +
          editData?.studentId?.studentName,
      });
    }

    if (dialogTitle === "Create" && open) {
      resetForm();
    }
  }, [open, editData]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_teaching_time")
            : t("modal_title_update_teaching_time")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_student")}
                </Typography>
                {/* <MultilineSelectStudent
                  onChange={(event, val) => setSelectedStudents(val)}
                  value={selectedStudents}
                  classId={classId}
                /> */}
                <SelectStudentByClass
                  onChange={setStudentVal}
                  value={studentVal}
                  classId={classId}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_subject")}
                </Typography>
                <SelectSubjectByClassId
                  classId={classId}
                  value={values?.subjectId}
                  onChange={(val) => setFieldValue("subjectId", val)}
                />
                {!!errors.subjectId?.id && touched.subjectId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.subjectId?.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_start_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.fromDate}
                  onChange={(val) => setFieldValue("fromDate", val || null)}
                />
                {!!errors.fromDate && touched.fromDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.fromDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_end_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.toDate}
                  onChange={(val) => setFieldValue("toDate", val || null)}
                />
                {!!errors.toDate && touched.toDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.toDate}
                  </FormHelperText>
                )}
              </Grid>

              {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_start_time")}
                </Typography>
                <SelectTimePicker
                  value={values?.startTime || null}
                  onChange={(val) => setFieldValue("startTime", val || "")}
                />
                {!!errors.startTime && touched.startTime && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startTime}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_end_time")}
                </Typography>
                <SelectTimePicker
                  value={values?.endTime || null}
                  onChange={(val) => setFieldValue("endTime", val || "")}
                />
                {!!errors.endTime && touched.endTime && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endTime}
                  </FormHelperText>
                )}
              </Grid> */}

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_lesson")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={10}
                  size="small"
                  className="text-field"
                  placeholder={t("thead_lesson")}
                  {...getFieldProps("lesson")}
                  error={Boolean(touched.lesson && errors.lesson)}
                  helperText={touched.lesson && errors.lesson}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    className={t("class-btn-create")}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
